import { FILE_VALIDATION_ERROR } from './constants'
import { FileObjective, FormFile } from './types'

export const getFileSizeText = (size: number) => {
  const sizeInKb = size / 1024
  if (sizeInKb < 1024) return `${sizeInKb.toFixed(2)} KB`

  const sizeInMb = sizeInKb / 1024
  return `${sizeInMb.toFixed(2)} MB`
}

export const validateFiles = (values: FormFile[]) => {
  if (!values.length) return FILE_VALIDATION_ERROR.COUNT

  if (values.length > 2) return FILE_VALIDATION_ERROR.MAX_COUNT

  if (values.some(file => !file.objective)) return FILE_VALIDATION_ERROR.EMPTY_OBJECTIVE

  if (!values.some(file => file.objective === FileObjective.DATA_DICTIONARY))
    return FILE_VALIDATION_ERROR.DATA_DICTIONARY_REQUIRED

  // should be two files with different objectives
  if (values?.[0]?.objective === values?.[1]?.objective) return FILE_VALIDATION_ERROR.SAME_OBJECTIVE

  return undefined
}
